import React from 'react';

import { WhiteLabelTitle } from 'types/models/white-label';
import getWhiteLabelConfig from 'utils/get-white-label-config';

import FarmbotIcon from './farmbot-logo-horizontal.svg?react';
import MinebotIcon from './minebot-logo-horizontal.svg?react';
import RanchbotIcon from './ranchbot-logo-horizontal.svg?react';

const { title } = getWhiteLabelConfig();

const Icon = (() => {
  switch (title) {
    case WhiteLabelTitle.RANCHBOT:
      return RanchbotIcon;
    case WhiteLabelTitle.MINEBOT:
      return MinebotIcon;
    case WhiteLabelTitle.FARMBOT:
    default:
      return FarmbotIcon;
  }
})();

type Props = {
  style?: React.CSSProperties;
};

function FarmbotLogoHorizontal({
  style = { verticalAlign: 'middle', height: '27px', width: '134px' }
}: Props): JSX.Element {
  return <Icon title={`${title} Logo`} style={style} />;
}

export default FarmbotLogoHorizontal;
